import axios from 'axios';
import { getApiBaseUrl } from './env'

// 上传文件
export const upload_file = (data) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        console.log('formData', formData, data)
        for (let i in data) {
            formData.append(i, data[i]);
        }
    
        axios.post(getApiBaseUrl() + '/admin/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data' // 表单提交格式
            },
            withCredentials: true
        }).then(res => {
            if(res.status == 200) {
                resolve(res.data);
            }
        }).catch((e) => {
            reject(e);
        })
    })
}

/**
 * 复制字符串到剪贴板（自动适配版本）
 * @param {string} text - 要复制的字符串
 * @returns {Promise<boolean>} 复制成功返回true，失败返回false
 */
export async function copyText(text) {
  // 优先使用现代API
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      // 现代API失败，降级到兼容方案
      return copyTextToClipboardCompat(text);
    }
  } else {
    // 不支持现代API，直接用兼容方案
    return copyTextToClipboardCompat(text);
  }
}

// 复用兼容方案的函数（内部调用）
function copyTextToClipboardCompat(text) {
  const input = document.createElement('input');
  input.value = text;
  document.body.appendChild(input);
  input.select();
  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (err) {
    success = false;
  }
  document.body.removeChild(input);
  return success;
}

// 递归树数组
export function findJudgeDimensionByIdOptimize(arr, targetId) {
    let result = null;
    // 使用some遍历，找到结果后可立即终止循环
    arr.some(item => {
        if (item.id === targetId) {
            result = item.judge_dimension || [];
            return true; // 终止some循环
        }
        if (item.child && Array.isArray(item.child)) {
            result = findJudgeDimensionByIdOptimize(item.child, targetId);
            return result !== null; // 递归找到结果则终止循环
        }
        return false;
    });
    return result;
}


// 递归树数组
export function findByIdTree(arr, target, key, childKey = 'children') {
    let result = null;
    // 使用some遍历，找到结果后可立即终止循环
    arr.some(item => {
        if (item[key] == target) {
            result = item || {};
            return true; // 终止some循环
        }
        if (item[childKey] && Array.isArray(item[childKey])) {
            result = findByIdTree(item[childKey], target, key, childKey);
            return result !== null; // 递归找到结果则终止循环
        }
        return false;
    });
    return result;
}